import {BrowserModule, Meta} from '@angular/platform-browser';
import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LoginComponent} from './pages/login/login.component';
import {HomeComponent} from './pages/home/home.component';
import {NgxSpinnerModule} from 'ngx-spinner';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LoadingBarHttpClientModule} from '@ngx-loading-bar/http-client';
import {CommonModule} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ProductComponent} from './pages/product/product.component';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import {InViewportModule} from 'ng-in-viewport';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {HeaderComponent} from './parts/header/header.component';
import {FooterComponent} from './parts/footer/footer.component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {ExperiencesComponent} from './pages/experiences/experiences.component';
import {NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule} from 'ngx-google-analytics';
import {PagenotfoundComponent} from './pages/pagenotfound/pagenotfound.component';
import {TncComponent} from './pages/tnc/tnc.component';
import {PpComponent} from './pages/pp/pp.component';
import {ContactUsComponent} from './pages/contact-us/contact-us.component';
import {AboutComponent} from './pages/about/about.component';
import {FaqsComponent} from './pages/faqs/faqs.component';
import {ProductEnquiryComponent} from './pages/product-enquiry/product-enquiry.component';
import {ShareButtonsModule} from 'ngx-sharebuttons/buttons';
import {ShareIconsModule} from 'ngx-sharebuttons/icons';
import {InterceptorService} from './services/interceptor.service';
import {MyaccountComponent} from './pages/myaccount/myaccount.component';
import {OrdersComponent} from './pages/myaccount/orders/orders.component';
import {PaymentsComponent} from './pages/myaccount/payments/payments.component';
import {BucketComponent} from './pages/myaccount/bucket/bucket.component';
import {ProfileComponent} from './pages/myaccount/profile/profile.component';
import {OrderSummaryComponent} from './pages/order-summary/order-summary.component';
import {StandardComponent} from './pages/home/standard/standard.component';
import {ProductCardComponent} from './components/product-card/product-card.component';
import {BannerTopComponent} from './components/home/standard/banner-top/banner-top.component';
import {CategoriesComponent} from './components/home/standard/categories/categories.component';
import {PopularExperiencesComponent} from './components/home/standard/popular-experiences/popular-experiences.component';
import {PremiumExperiencesComponent} from './pages/listing/premium-experiences/premium-experiences.component';
import {StandardExperiencesComponent} from './pages/listing/standard-experiences/standard-experiences.component';
import {DiscountSliderComponent} from './components/home/standard/discount-slider/discount-slider.component';
import {TrendingProductsComponent} from './components/home/standard/trending-products/trending-products.component';
import {NewArrivalsComponent} from './components/home/standard/new-arrivals/new-arrivals.component';
import {ListingFiltersComponent} from './components/listing-filters/listing-filters.component';
import {StandardProductComponent} from './pages/product/standard-product/standard-product.component';
import {MostLovedBrandsComponent} from './components/home/standard/most-loved-brands/most-loved-brands.component';
import {WishlistComponent} from './components/micro/wishlist/wishlist.component';
import {ComingSoonComponent} from './pages/coming-soon/coming-soon.component';
import {SocialLoginModule, SocialAuthServiceConfig, GoogleLoginProvider, FacebookLoginProvider} from 'angularx-social-login';
import {ErrorInterceptor, JwtInterceptor} from './_helpers';
import {GoogleTagManagerModule} from 'angular-google-tag-manager';
import {SearchComponent} from './pages/search/search.component';
import {SearchExclusiveComponent} from './pages/search-exclusive/search-exclusive.component';
import {CanDeactivateGuard} from './services/can-deactivate.guard';
import {AutosearchComponent} from './parts/autosearch/autosearch.component';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import {LocationComponent} from './pages/location/location.component';
import {SharingComponent} from './components/micro/sharing/sharing.component';
import {StandardProductCardComponent} from './components/standard-product-card/standard-product-card.component';
import {SingletonSecureStorageService} from './services/singleton-secure-storage.service';
import {ExclusiveTopSliderComponent} from './components/home/exclusive/exclusive-top-slider/exclusive-top-slider.component';
import {ExclusiveCategoriesComponent} from './components/home/exclusive/exclusive-categories/exclusive-categories.component';
import {MatDatepicker, MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule, MatLabel} from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
/**26 March**/
import { LiveMatchesComponent } from './pages/ipl/live-matches/live-matches.component';
import {MatExpansionModule} from '@angular/material/expansion';
import { SwiperModule } from 'swiper/angular';
import { LiveMatchesCardComponent } from './pages/ipl/live-matches/live-matches-card/live-matches-card.component';
import { LandingPageComponent } from './pages/ipl/live-matches/landing-page/landing-page.component';
import { MyCouponsComponent } from './pages/ipl/live-matches/my-coupons/my-coupons.component';
import { PollHistoryComponent } from './pages/ipl/live-matches/poll-history/poll-history.component';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { CountdownModule } from 'ngx-countdown';
import { CorporateBookingComponent } from './pages/corporate-booking/corporate-booking.component';
//17 Aug 2022
import { ReschedulePageComponent } from './pages/reschedule-page/reschedule-page.component';
import { OrderConfirmationStatusComponent } from './pages/order-confirmation-status/order-confirmation-status.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    ProductComponent,
    HeaderComponent,
    FooterComponent,
    ExperiencesComponent,
    PagenotfoundComponent,
    TncComponent,
    PpComponent,
    ContactUsComponent,
    AboutComponent,
    FaqsComponent,
    ProductEnquiryComponent,
    MyaccountComponent,
    OrdersComponent,
    PaymentsComponent,
    BucketComponent,
    ProfileComponent,
    OrderSummaryComponent,
    StandardComponent,
    ProductCardComponent,
    BannerTopComponent,
    CategoriesComponent,
    PopularExperiencesComponent,
    PremiumExperiencesComponent,
    StandardExperiencesComponent,
    DiscountSliderComponent,
    TrendingProductsComponent,
    NewArrivalsComponent,
    ListingFiltersComponent,
    StandardProductComponent,
    MostLovedBrandsComponent,
    WishlistComponent,
    ComingSoonComponent,
    SearchComponent,
    SearchExclusiveComponent,
    AutosearchComponent,
    LocationComponent,
    SharingComponent,
    StandardProductCardComponent,
    ExclusiveTopSliderComponent,
    ExclusiveCategoriesComponent,
    LiveMatchesComponent,
    LiveMatchesCardComponent,
    LandingPageComponent,
    MyCouponsComponent,
    PollHistoryComponent,
    CorporateBookingComponent,
    ReschedulePageComponent,
    OrderConfirmationStatusComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule.withServerTransition({appId: 'serverApp'}),
    HttpClientModule,
    AppRoutingModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    LoadingBarHttpClientModule,
    NgxGoogleAnalyticsModule.forRoot('G-MGLX0Q9HKL'),
    NgxGoogleAnalyticsRouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxSkeletonLoaderModule,
    AutocompleteLibModule,
    InViewportModule,
    MatBottomSheetModule,
    InfiniteScrollModule,
    MatExpansionModule,
    SwiperModule,
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
    ShareButtonsModule.withConfig({
      debug: true
    }),
    ShareIconsModule,
    SocialLoginModule,
    GoogleTagManagerModule.forRoot({
      id: environment.gtmCode,
    }),
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatNativeDateModule,
    ClipboardModule,
    CountdownModule

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true},
    SingletonSecureStorageService,
    {
      provide: APP_INITIALIZER,
      useFactory: (ds: SingletonSecureStorageService) => () => ds.init(),
      deps: [SingletonSecureStorageService],
      multi: true
    },
    CanDeactivateGuard,
    {
      provide: 'SocialAuthServiceConfig', useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider('913828893016-a2eu8uriglo8b60cv7v9cp8dpr4d4voa.apps.googleusercontent.com')
          },
          {id: FacebookLoginProvider.PROVIDER_ID, provider: new FacebookLoginProvider('1928117584103549')}
        ]
      } as SocialAuthServiceConfig,
    },
    Meta],
  bootstrap: [AppComponent]
})
export class AppModule {
}
